module.exports = __webpack_public_path__ + "static/media/51.53bebc04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/51.jpg
// module id = 741
// module chunks = 0